import React, {Component} from 'react';
import axios from 'axios';
import Card from './Card';
import Video from './Video';
import Header from '../Headers';
import ReactGA from 'react-ga';
import Footer from '../../footer';
import config from 'config'


export default class Index extends Component {
    constructor() {
        super();
        this.state = {
            data: []
        }
    }

    componentDidMount() {
        axios.get(`${config.REV_URL}/mediadetails`)
            .then(res => {
                //   this.setState({data: res.data});
                this.setState({data: res.data.result[0].mediaList});
            });
        this.initializeReactGA();
        window.scrollTo(0, 0);
        // this.props.store.homeType(false);
    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/media');
    }

    render() {
        let content;
        if (this.state.data.length === 0) {
            <h4 className="text-center">No data found</h4>
        } else {
            console.log(this.state.data);
            content = this.state.data.map((each, index) => <Card {...each} key={index}/>);
        }

        return (
            <div>
                <Header/>
                <section className="breadcrumbs">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <h2>Media</h2>
                            <ol>
                                <li><a href="/">Home</a></li>
                                <li>Media</li>
                            </ol>
                        </div>
                    </div>
                </section>
                <section className="mainPannel">
                    <div className="container media-div">
                        <section id="services" className="services">
                            <div className="container" data-aos="fade-up">
                                <div className="section-titles">
                                    <h3 className="heading_tow">News Media Coverage</h3>
                                </div>
                            </div>
                        </section>

                        <div className="row">
                            {content}
                        </div>
                        <div className="row">
                        </div>
                        <br></br>
                        <br></br>
                        <Video/>
                        <br></br>
                    </div>
                </section>
                <Footer/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/media/Index.js